import React from 'react';
import { Link } from 'react-router-dom';
import FadeUp from '../ui/FadeUp';
import SectionHeader from '../ui/SectionHeader';
import { PartsSearchForm } from '../ui/PartsSearchForm';

export default function SearchSection() {
  return (
    <section id="search" style={{ background: 'var(--ice)', padding: '5rem 2rem' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <FadeUp>
          <SectionHeader
            tag="Find Your Part"
            title="Parts Search"
            subtitle="Search our inventory by vehicle or part name. Results link directly to available listings via CarParts.com."
          />
        </FadeUp>

        <FadeUp delay={100}>
          <div style={{
            background: 'white', borderRadius: 16, padding: '2.5rem',
            boxShadow: '0 4px 40px rgba(13,27,42,0.1)', marginTop: '2.5rem',
          }}>
            <PartsSearchForm />
            <p style={{ marginTop: '1.25rem', fontSize: '0.82rem', color: 'var(--text-light)', textAlign: 'center' }}>
              Can't find what you need?{' '}
              <Link to="/request-part" style={{ color: 'var(--orange)', textDecoration: 'none' }}>Request a specific part</Link>
              {' '}and we'll locate it for you. Call us at{' '}
              <a href="tel:5197743338" style={{ color: 'var(--orange)', textDecoration: 'none' }}>(519) 774-3338</a>.
            </p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
